import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { articles } from '@/mocks/articles';

const relatedArticles = [
  { id: 'how-to-use-litbuy-spreadsheet', title: 'How to Use a LitBuy Spreadsheet Effectively' },
  { id: 'litbuy-spreadsheet-mistakes', title: 'Common Mistakes When Using a LitBuy Spreadsheet' },
  { id: 'litbuy-spreadsheet-features', title: 'LitBuy Spreadsheet Features Explained' },
];

export default function TipsPage() {
  return (
    <main>
      <Navbar />
      <ArticleLayout article={articles['litbuy-spreadsheet-tips']} relatedArticles={relatedArticles} />
      <Footer />
    </main>
  );
}